export const addStock = async (stockData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "addStock", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...stockData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = stockData;
        data.id = jsonResponse?.data?.id;
        jsonResponse.data = data;
    }
    console.log('Add Stock Response:', response);
    return jsonResponse;
};
export const updateStock = async (stockId, stockData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "updateStock", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: stockId, ...stockData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = stockData;
        data.id = stockId;
        jsonResponse.data = data;
    }
    console.log('Update Stock Response:', response);
    return jsonResponse;
};
export const deleteStock = async (stockId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "deleteStock", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: stockId})
    });
    return await response.json();
};
